import React from 'react';
import { Section } from './ui/Section';
import { XCircle, CheckCircle2 } from 'lucide-react';
import { motion } from 'framer-motion';
export function ProblemSection() {
  const problems = ['Has probado pastillas, cremas o extensores sin resultados', 'Sientes que tu tamaño afecta tu confianza', 'Quieres un método natural, sin efectos secundarios', 'Buscas resultados reales y duraderos', 'Estás listo para un cambio de verdad', 'Quieres recuperar tu seguridad y dominio'];
  return <Section background="darker" data-id="element-133">
      <div className="text-center mb-12" data-id="element-134">
        <h2 className="text-3xl md:text-4xl font-bold text-white uppercase leading-tight" data-id="element-135">
          SI HAS PROBADO DE TODO Y NADA FUNCIONÓ...{' '}
          <span className="text-[#22C55E]" data-id="element-136">VARAMAX ES PARA TI.</span>
        </h2>
      </div>

      <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-137">
        <motion.div initial={{
        opacity: 0,
        x: -50
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="relative" data-id="element-138">
          <div className="absolute inset-0 bg-gradient-to-tr from-[#0B1A0B] to-transparent opacity-60 z-10" data-id="element-139"></div>
          <img src="https://images.unsplash.com/photo-1581009146145-b5ef050c2e1e?q=80&w=2070&auto=format&fit=crop" alt="Hombre frustrado" className="rounded-xl shadow-2xl grayscale contrast-125 w-full object-cover h-[400px]" data-id="element-140" />
          <div className="absolute bottom-4 left-4 z-20 bg-red-600/90 text-white px-4 py-2 rounded font-bold uppercase text-sm" data-id="element-141">
            ¿Te sientes identificado?
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 50
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="space-y-4" data-id="element-142">
          {problems.map((item, index) => <div key={index} className="flex items-start gap-4 p-3 rounded-lg hover:bg-[#1A2A1A] transition-colors" data-id="element-143">
              <CheckCircle2 className="w-6 h-6 text-[#22C55E] shrink-0 mt-1" data-id="element-144" />
              <p className="text-lg text-gray-200 font-medium" data-id="element-145">{item}</p>
            </div>)}
        </motion.div>
      </div>
    </Section>;
}